// Generic city-service data loader
// Each service has its own JSON file to avoid babel plugin issues

const serviceDataFiles = {
  "residential-painting": require('./cityPaintingData.json'),
  "remodeling-renovations": require('./city_remodeling_renovations_data.json'),
  "drywall-repair": require('./city_drywall_repair_data.json'),
  "carpentry": require('./city_carpentry_data.json'),
  "tile-installation": require('./city_tile_installation_data.json'),
  "exterior-siding": require('./city_exterior_siding_data.json'),
  "deck-construction": require('./city_deck_construction_data.json'),
  "mold-remediation": require('./city_mold_remediation_data.json'),
  "parking-lot-striping": require('./city_parking_lot_striping_data.json'),
  "brick-masonry": require('./city_brick_masonry_data.json'),
  "roof-repairs": require('./city_roof_repairs_data.json'),
};

const serviceMeta = require('./serviceMetadata.json');

export const getServiceMeta = (serviceId) => serviceMeta[serviceId] || null;

export const getCityDataForService = (serviceId, citySlug) => {
  const cities = serviceDataFiles[serviceId];
  if (!cities) return null;
  return cities.find(c => c.slug === citySlug) || null;
};

export const getAllCitiesForService = (serviceId) => serviceDataFiles[serviceId] || [];

export const getAllServiceIds = () => Object.keys(serviceDataFiles);
